var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#ffffff","d":"M9.5 3h2.5v-3h-2.5c-1.93 0-3.5 1.57-3.5 3.5v1.5h-2v3h2v8h3v-8h2.5l0.5-3h-3v-1.5c0-0.271 0.229-0.5 0.5-0.5z"}));
}

Facebook.defaultProps = {"version":"1.1","width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = Facebook;

Facebook.default = Facebook;
